import React from 'react';

const STAR_PATH =
  'M12 2l2.9 6.3 6.9.8-5.1 4.7 1.4 6.8L12 17l-6.1 3.6 1.4-6.8L2.2 9.1l6.9-.8z';

type GoldStarsProps = {
  count?: number;
  /** Pixel size for each star (sets inline width/height). */
  size?: number;
  /** Class applied to each <svg> (e.g. responsive sizing via CSS). */
  className?: string;
  /** Gap between stars in px. */
  gap?: number;
};

/** Renders N filled gold (#FBBF24) stars, matching the approved review mockups. */
const GoldStars: React.FC<GoldStarsProps> = ({
  count = 5,
  size,
  className,
  gap = 4,
}) => (
  <span className="inline-flex" style={{ gap: `${gap}px` }}>
    {Array.from({ length: count }).map((_, i) => (
      <svg
        key={i}
        viewBox="0 0 24 24"
        className={className}
        style={
          size !== undefined
            ? { width: size, height: size, fill: '#FBBF24', flexShrink: 0 }
            : { fill: '#FBBF24', flexShrink: 0 }
        }
        aria-hidden="true"
      >
        <path d={STAR_PATH} />
      </svg>
    ))}
  </span>
);

export default GoldStars;
